export const CookieTableHeaders = {
  name: 'Name',
  description: 'Description',
  duration: 'Duration',
  type: 'Type',
};
